import React from 'react';
import Shopping from 'components/Tvendo/Shopping/Operations/List';

export default function () {
  return <Shopping />;
}
